// Added by Sejune Oh on 2020-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { useTheme, makeStyles, Theme, createStyles } from '@material-ui/core'

// UI
import {
  ContainedButton as MaterialContainerButton,
  ButtonProps as MaterialButtonProps,
} from '@/components/_primes/v2'

// Constants
import { GREY_COLOR, RED_COLOR } from '@/styles/Theme'

interface ButtonProps extends MaterialButtonProps {
  /** Button의 색상 타입 */
  buttonType?: 'default' | 'task' | 'danger'
}

/**
 *  Material UI 의 Button을 커스터마이징한 UI 입니다. <br />
 *  기본적으로는 https://material-ui.com/api/button/ 을 따릅니다. <br />
 */
const ContainedButton: FC<ButtonProps> = ({ buttonType = 'default', customProps,...props }) => {
  const theme = useTheme()
  const classes = useStyles(theme)

  return (
    <MaterialContainerButton
      className={classes.btn}
      data-type={buttonType}
      data-disabled={props.disabled}
      customProps={customProps}
      {...props}
    ></MaterialContainerButton>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btn: {
      minWidth: '100%',
      '&[data-type=task]': {
        backgroundColor: '#145c82',
        border: '1px solid #437c9b',
        borderColor: '#437c9b',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#0e405b',
        },
      },
      '&[data-type=danger]': {
        backgroundColor: RED_COLOR,
        border: '1px solid #ff2c2c',
        borderColor: '#ff2c2c',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#7b1010',
        },
      },
      '&[data-type=default]': {
        backgroundColor: GREY_COLOR,
        border: '1px solid #676767',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#2e2e2e',
        },
      },
      '&[data-disabled=true]': {
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
        border: '1px solid #676767',
        color: '#fff',
      },
    },
  })
)

export default ContainedButton
